<template>
    <v-row>
      <v-col cols="12">
          <staff-attendence-card> </staff-attendence-card> 
      </v-col>
    </v-row>
  </template>
  <script>
  import StaffAttendenceCard from "@/components/report/StaffAttendenceCard";
  
  export default {
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Staff Attendence",
    },
  
    components: {
        StaffAttendenceCard
    },
  
    data() {
      return {
      };
    },
  };
  </script>